import React from "react"

import { cn } from "../helpers/utils"

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-white", className)} {...props} />
}

export { Skeleton }
